/**
 * @param props
 * @param {VariantWasSampledReduxItem} props.data
 * @param {bool} props.hasSampled
 * @returns {boolean}
 */
const hasSampledAndRatedVariantSelectorUtil = (props) => {
  const {
    data,
    hasSampled
  } = props

  const validPssAnswers = ['not_like', 'like', 'super_like']
  const isPssAnswerValid = validPssAnswers.includes(data?.pssAnswer)

  return (
    hasSampled === true && isPssAnswerValid
  )
}

export default hasSampledAndRatedVariantSelectorUtil
